__webpack_require__.p = "https://assets.canny.io/d3c35a681c65630fd6d99dbf383f8ef4a19d394e/";